/**
 * Color helpers used across brand surfaces.
 */

/**
 * Mix a hex color with white at the given opacity, returning an `rgb(...)`
 * string. Produces the white-tinted card bodies of the stat-card pattern
 * (per `frontend-standards/patterns.md` § Stat / dashboard card).
 *
 * `tint("#1F4E79", 0.15)` → 15% navy on white → `rgb(228, 235, 240)`.
 */
export const tint = (hex: string, alpha: number): string => {
  const h = hex.replace("#", "")
  const r = parseInt(h.slice(0, 2), 16)
  const g = parseInt(h.slice(2, 4), 16)
  const b = parseInt(h.slice(4, 6), 16)
  const mix = (c: number) => Math.round(255 + (c - 255) * alpha)
  return `rgb(${mix(r)}, ${mix(g)}, ${mix(b)})`
}
